import { ColorDotBadge } from "./ColorDotBadge";
import { useTranslation } from "react-i18next";

/**
 * AD-188: the account status badges — Active (green), Pending (yellow), Deactive (red).
 * Codes are AdStudioUserProfile::STATUS_*.
 */
export const USER_STATUS = {
    ACTIVE: { code: 1, key: 'active', color: 'var(--sma-color-green-6)' },
    PENDING: { code: 2, key: 'pending', color: 'var(--sma-color-yellow-6)' },
    DEACTIVE: { code: 3, key: 'deactive', color: 'var(--sma-color-red-6)' },
};

const BY_CODE = Object.fromEntries(Object.values(USER_STATUS).map((status) => [status.code, status]));

export const UserStatusBadge = ({ status, ...props }) => {
    const { t } = useTranslation();
    const entry = BY_CODE[status] || USER_STATUS.ACTIVE;

    return (
        <ColorDotBadge
            color={entry.color}
            bg={`color-mix(in srgb, ${entry.color} 10%, transparent)`}
            radius="xl"
            tt="none"
            fz={11}
            fw={700}
            h={20}
            px={10}
            {...props}
        >
            {t(`users.status.${entry.key}`)}
        </ColorDotBadge>
    );
};
